import { AppCard, AppUseIcon } from 'components/ui';
import { useRef, useState } from 'react';

import { AppButton } from 'components/form';
import ReleaseNotesRepo from '../ReleaseNotesRepo';
import { Slide } from '@mui/material';
import { t } from 'utilities/TranslationUtils';

export const ProductUpdatesSection = () => {
  const [areAllReleaseNotesShown, setAreAllReleaseNotesShown] = useState(false);
  const layoutContainerRef = useRef(null);

  return (
    <AppCard title={t('homePage.ProductUpdates')}>
      <div className='product-updates'>
        <div className='product-updates-desc'>{t('homePage.ProductUpdatesText')}</div>

        <div className='overflow-hidden'>
          <Slide direction={'down'} in={!!areAllReleaseNotesShown} container={layoutContainerRef.current} mountOnEnter unmountOnExit>
            <div>
              {ReleaseNotesRepo()
                .getAllReleaseNotes()
                .map((element, index) => ReleaseNotesRepo().CreateProductUpdateRow(element, index))}
            </div>
          </Slide>

          <AppButton
            className='mt-2 d-flex align-items-center'
            onClick={() => setAreAllReleaseNotesShown(!areAllReleaseNotesShown)}
            variant={'primary'}
          >
            {areAllReleaseNotesShown ? t('homePage.hideAllReleaseNotes') : t('homePage.showAllReleaseNotes')}
            <AppUseIcon
              name='ChevronBottom'
              className={`ml-2 transitioned ${areAllReleaseNotesShown ? 'rotate--180' : ''}`}
              color='currentColor'
              style={{ width: '15px' }}
              height='10'
            />
          </AppButton>
        </div>
      </div>
    </AppCard>
  );
};

export default ProductUpdatesSection;
